// extracted by mini-css-extract-plugin
module.exports = {"holder":"CodeBlock--holder","modeLabel":"CodeBlock--modeLabel"};